import React from 'react';

import {RequestFromD365} from 'components/request/actions/request-from-d365/request-from-d365';
import {EButtonType} from 'entities/metadata';
import {
    URL_REQUESTS_CLOSE,
    URL_REQUESTS_APPROVE,
    URL_REQUESTS_CREATE_APPROVE,
    URL_REQUESTS_REJECT,
    URL_REQUESTS_REQUIREMENT,
    URL_REQUESTS_SEND,
    URL_TAKE_TO_WORK_REQUESTS_NOT_DATE,
} from 'shared/constants/urls';
import {ERequestStatus} from 'store/slices/request-slice/request-slice-type';

import {REQUESTS_ENTITY_NAME} from '../constants/requests.constants';
import {ERequestFormFormKey} from '../request-form/request-form.constants';
import {DeleteButton} from './delete-button/request-delete-button';
import {EditingAndSaveFormButton} from './editing-and-save-form-button/editing-and-save-form-button';
import {OpenModalRequest} from './open-modal-request/open-modal-request';
import {RequestDocJournalUpdateButton} from './request-doc-journal-update-button/request-doc-journal-update-button';
import {RequestSaveButton} from './request-save-button/request-save-button';

/**
 * Функция для получения нужного действия
 */
export const RequestActionTypeResolver = (
    requestStatus: ERequestStatus,
    requestFormKey: string,
    requestCommentId?: string,
    entityName?: string,
    onSubmit?: () => void,
) => {
    switch (requestStatus) {
    /**
         * Закрыть запрос
         */
    case ERequestStatus.CLOSE_REQUEST:
        return () => (
            <RequestSaveButton
                url={URL_REQUESTS_CLOSE}
                requestFormKey={requestFormKey}
                actionTitle="Закрыть запрос"
                actionIcon="Confirm"
                status={ERequestStatus.CLOSE_REQUEST}
                entityName={entityName}
                buttonType={EButtonType.primary}
            />
        );
        /**
         * Оставить комментарий
     */
    case ERequestStatus.COMMENT_REQUEST:
    case ERequestStatus.REQUEST_RESPONSE:
        return () => (
            <OpenModalRequest
                requestCommentId={requestCommentId}
                requestFormKey={requestFormKey}
                actionTitle="Оставить комментарий"
                actionIcon="PlusCircleOutlined"
                modalName="requestFormModal"
                modalEntityName={`${REQUESTS_ENTITY_NAME}.comment`}
                status={ERequestStatus.COMMENT_REQUEST}
                buttonType={EButtonType.primary}
            />
        );
        /**
         * Взять в работу
         */
    case ERequestStatus.TAKE_TO_WORK_REQUEST_NOT_DATE:
        return () => (
            <RequestSaveButton
                url={URL_TAKE_TO_WORK_REQUESTS_NOT_DATE}
                requestFormKey={ERequestFormFormKey.REQUESTS}
                actionTitle="Взять в работу"
                actionIcon="Case"
                status={ERequestStatus.TAKE_TO_WORK_REQUEST_NOT_DATE}
                entityName={entityName}
                buttonType={EButtonType.primary}
            />
        );
    case ERequestStatus.TAKE_TO_WORK_REQUEST:
        return () => (
            <OpenModalRequest
                requestCommentId={requestCommentId}
                requestFormKey={requestFormKey}
                actionTitle="Взять в работу"
                modalName="requestFormModal"
                modalEntityName={`${REQUESTS_ENTITY_NAME}.take.work`}
                status={ERequestStatus.TAKE_TO_WORK_REQUEST}
                buttonType={EButtonType.primary}
            />
        );
        /**
         * Назначить ответственного
         */
    case ERequestStatus.ASSIGN_RESPONSIBLE:
        return () => (
            <OpenModalRequest
                requestCommentId={requestCommentId}
                requestFormKey={requestFormKey}
                actionTitle="Назначить ответственного сотрудника"
                actionIcon="AddUser"
                modalName="requestFormModal"
                modalEntityName={`${REQUESTS_ENTITY_NAME}.assigning.person`}
                status={ERequestStatus.ASSIGN_RESPONSIBLE}
                buttonType={EButtonType.primary}
            />
        );
    case ERequestStatus.REQUEST_PROLONGATION:
        return () => (
            <OpenModalRequest
                requestCommentId={requestCommentId}
                requestFormKey={requestFormKey}
                actionTitle="Запросить продление"
                actionIcon="ClockOutlined"
                modalName="requestFormModal"
                modalEntityName={`${REQUESTS_ENTITY_NAME}.prolongation`}
                status={ERequestStatus.REQUEST_PROLONGATION}
                buttonType={EButtonType.primary}
                isFileComponent
            />
        );
        /**
         * Сформировать ответ
         */
    case ERequestStatus.GENERATE_RESPONSE:
        return () => (
            <OpenModalRequest
                requestCommentId={requestCommentId}
                requestFormKey={requestFormKey}
                actionTitle="Сформировать ответ"
                actionIcon="Envelop"
                modalName="requestFormModal"
                modalEntityName="generate.response"
                status={ERequestStatus.GENERATE_RESPONSE}
                buttonType={EButtonType.primary}
                isFileComponent
            />
        );
        /**
         * Отправить
         */
    case ERequestStatus.REPLY_REQUEST:
        return () => (
            <RequestSaveButton
                url={URL_REQUESTS_REQUIREMENT}
                requestFormKey={requestFormKey}
                actionTitle="Согласовать"
                actionIcon="TickOutlined"
                status={ERequestStatus.REPLY_REQUEST}
                buttonType={EButtonType.primary}
            />
        );
    case ERequestStatus.APPROVE_REQUEST:
        return () => (
            <RequestSaveButton
                url={URL_REQUESTS_APPROVE}
                requestFormKey={requestFormKey}
                actionTitle="Согласовать"
                actionIcon="TickOutlined"
                status={ERequestStatus.APPROVE_REQUEST}
                buttonType={EButtonType.primary}
            />
        );
    case ERequestStatus.REJECT:
    case ERequestStatus.REJECT_REQUEST:
        return () => (
            <RequestSaveButton
                url={URL_REQUESTS_REJECT}
                requestFormKey={requestFormKey}
                actionTitle="Отклонить"
                actionIcon="TickOutlined"
                status={ERequestStatus.REJECT}
                buttonType={EButtonType.primary}
            />
        );
        /**
         * Отправить на согласование
         */
    case ERequestStatus.SEND_FOR_APPROVAL_REQUEST:
        return () => (
            <RequestSaveButton
                url={URL_REQUESTS_CREATE_APPROVE}
                requestFormKey={requestFormKey}
                actionTitle="Отправить на согласование"
                actionIcon="TickOutlined"
                status={ERequestStatus.SEND_FOR_APPROVAL_REQUEST}
                buttonType={EButtonType.primary}
            />
        );
    case ERequestStatus.REQUEST_RESPONSE_SEND:
        return () => (
            <RequestSaveButton
                url={URL_REQUESTS_SEND}
                requestFormKey={requestFormKey}
                actionTitle="Закрыть запрос"
                actionIcon="Confirm"
                status={ERequestStatus.REQUEST_RESPONSE_SEND}
                buttonType={EButtonType.primary}
            />
        );
    case ERequestStatus.PROLONGATION_REQUEST:
        return () => (
            <OpenModalRequest
                requestCommentId={requestCommentId}
                requestFormKey={requestFormKey}
                actionTitle="Запрос на продление"
                actionIcon="ClockOutlined"
                modalName="requestFormModal"
                modalEntityName="request.prolongation"
                status={ERequestStatus.REQUEST_PROLONGATION}
                buttonType={EButtonType.primary}
                isFileComponent
            />
        );
    case ERequestStatus.GENERATE_ADD_PLACEMENT_DOC_RESPONSE:
        return () => (
            <OpenModalRequest
                requestCommentId={requestCommentId}
                requestFormKey={requestFormKey}
                actionTitle="Сформировать ответ"
                actionIcon="ClockOutlined"
                modalName="requestFormModal"
                modalEntityName="request.generate.response.additional.placement"
                status={ERequestStatus.GENERATE_ADD_PLACEMENT_DOC_RESPONSE}
                buttonType={EButtonType.primary}
            />
        );
    case ERequestStatus.GENERATE_REJECTION_RESPONSE:
        return () => (
            <OpenModalRequest
                requestCommentId={requestCommentId}
                requestFormKey={requestFormKey}
                actionTitle="Отказ в доразмещении"
                actionIcon="ClockOutlined"
                modalName="requestFormModal"
                modalEntityName="request.generate.refusal"
                status={ERequestStatus.GENERATE_REJECTION_RESPONSE}
                buttonType={EButtonType.primary}
            />
        );
    case ERequestStatus.PROLONGATION_RESPONSE:
        return () => (
            <OpenModalRequest
                requestCommentId={requestCommentId}
                requestFormKey={requestFormKey}
                actionTitle="Сформировать решение о продлении"
                actionIcon="Selection"
                modalName="requestFormModal"
                modalEntityName="response.prolongation"
                status={ERequestStatus.PROLONGATION_RESPONSE}
                buttonType={EButtonType.primary}
                isFileComponent
            />
        );
    case ERequestStatus.EDIT_RESPONSE:
        return () => (
            <EditingAndSaveFormButton
                actionIcon="EditWithLine"
                text="Редактировать"
                onSubmit={onSubmit}
            />
        );
    case ERequestStatus.SEND_MESSAGE:
        return () => (
            <RequestSaveButton
                url={URL_REQUESTS_SEND}
                requestFormKey={requestFormKey}
                actionTitle="Отправить"
                actionIcon="Confirm"
                status={ERequestStatus.SEND_MESSAGE}
                buttonType={EButtonType.primary}
            />
        );
    case ERequestStatus.DELETE_REQUEST:
        return () => (
            <DeleteButton
                requestFormKey={requestFormKey}
                actionTitle="Удалить запрос"
                actionIcon="TrashXOutlined"
                status={ERequestStatus.DELETE_REQUEST}
                buttonType={EButtonType.default}
            />
        );
    case ERequestStatus.REQUEST_FROM_D365:
        return () => (
            <RequestFromD365 />
        );
        /**
         * Обновить реестр документов
         */
    case ERequestStatus.UPDATE_DOC_JOURNAL:
        return () => (
            <RequestDocJournalUpdateButton
                actionTitle="Обновить реестр документов"
                actionIcon="ReloadOutlined"
                buttonType={EButtonType.primary}
            />
        );
    default:
        return () => null;
    }
};
